var map = {
	"./Dana_dani.png": 708,
	"./Flavours_kerala.png": 416,
	"./Rebar71.png": 193,
	"./Relish.png": 320,
	"./Samadhan.png": 920,
	"./Shivakashi_Eng.png": 387,
	"./Tawa_punjab.jpg": 307,
	"./The Coastal Tawa Logo .png": 169,
	"./The Coastal Tawa Logo.png": 813,
	"./The_food_town.png": 340,
	"./The_street.png": 970,
	"./cherry_logo.png": 848,
	"./kinara.png": 923,
	"./tarang.png": 656,
	"./tribe.jpg": 807,
	"./wahini.png": 497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 756;